import PropTypes from 'prop-types';
import React from 'react';
const PaginationDot = ({ index, active, onClick }) => {
    const handleClick = (event) => {
        onClick(event, index);
    };
    return (React.createElement("button", { type: "button", className: "h-4 w-4 cursor-pointer border-0 bg-none p-0", onClick: handleClick },
        React.createElement("div", { className: `h-3 w-3 rounded-full m-1 ${active ? 'bg-blue-800' : 'bg-gray-300'}` })));
};
PaginationDot.propTypes = {
    active: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired
};
export default PaginationDot;
//# sourceMappingURL=PaginationDot.js.map